import { GAME_ADMIN_RESOURCES, PAGE_NAMES } from 'constant';
import zookeeper from 'assets/gameAdmin/zookeeper.png';
import zkRevert from 'assets/gameAdmin/changeLog.png';

import zkRevertDashboard from './zkChangeLogs';

import ZookeeperDashboard from './zooKeeper';
import zookeeperPreProd from './zooKeeperPreProd';
import ConfigUpdateDashboard from '../dashboard/configUpdate';

export const URL = {
	[GAME_ADMIN_RESOURCES.zookeeper]: `/${PAGE_NAMES.gameAdmin}/${GAME_ADMIN_RESOURCES.zookeeper}`,
	[GAME_ADMIN_RESOURCES.zkRevertDashboard]: `/${PAGE_NAMES.gameAdmin}/${GAME_ADMIN_RESOURCES.zkRevertDashboard}`,
	[GAME_ADMIN_RESOURCES.zkPreProd]: `/${PAGE_NAMES.gameAdmin}/${GAME_ADMIN_RESOURCES.zkPreProd}`,
	[GAME_ADMIN_RESOURCES.zkDashBoardUpdate]: `/${PAGE_NAMES.gameAdmin}/${GAME_ADMIN_RESOURCES.zkDashBoardUpdate}`
};

export const LABEL = {
	[GAME_ADMIN_RESOURCES.zookeeper]: 'ZooKeeper',
	[GAME_ADMIN_RESOURCES.zkRevertDashboard]: 'zkRevertDashboard',
	[GAME_ADMIN_RESOURCES.zkPreProd]: 'zkPreProd',
	[GAME_ADMIN_RESOURCES.zkDashBoardUpdate]: 'zkDashBoardUpdate'
};

export const COMPONENT = {
	[GAME_ADMIN_RESOURCES.zookeeper]: ZookeeperDashboard,
	[GAME_ADMIN_RESOURCES.zkRevertDashboard]: zkRevertDashboard,
	[GAME_ADMIN_RESOURCES.zkPreProd]: zookeeperPreProd,
	[GAME_ADMIN_RESOURCES.zkDashBoardUpdate]: ConfigUpdateDashboard
};

export const IMAGE_SOURCE = {
	[GAME_ADMIN_RESOURCES.zookeeper]: zookeeper,
	[GAME_ADMIN_RESOURCES.zkRevertDashboard]: zkRevert,
	[GAME_ADMIN_RESOURCES.zkPreProd]: zookeeper,
	[GAME_ADMIN_RESOURCES.zkDashBoardUpdate]: zookeeper
};
